import { Component, input, computed } from "@angular/core";
import { NgClass, formatDate, DatePipe } from "@angular/common";
import { Table } from "../buildings.component";
import { InfoTableComponent } from "../../info-table/info-table.component";
import { EvExpandedIconComponent } from 'ev-expanded-icon';
import { PublicBuildingInfo } from "src/models/estate/public-building-info.model";

@Component({
    selector: "building-change",
    templateUrl: "./building-change.component.html",
    styleUrls: ["../buildings.component.scss", "./building-change.component.scss"],
    imports: [NgClass, EvExpandedIconComponent, InfoTableComponent, DatePipe]
})
export class BuildingChangeComponent {
    buildingChange = input<PublicBuildingInfo | null>(null);
    infoExpaned: boolean = false;

    changeDisplayTable = computed<Table | null>(() => {
        const bc = this.buildingChange();
        if (!bc) {
            return null;
        }

        const left: any[] = [];
        const right: any[] = [];
        const header: string = bc.buildingType;
        const arealInfo: number = bc.usableArea;

        left.push({ name: "Bygningstype", value: bc.buildingType });
        left.push({ name: "Bygningsstatus", value: bc.buildingStatus });
        left.push({ name: "Næringsgruppe", value: bc.buildingPurpose });
        left.push({ name: "Påbygg/tilbygg", value: bc.extensionType });
        left.push({ name: "Antall etasjer", value: bc.numFloors });
        left.push({ name: "Antall boliger", value: bc.numFunctionalUnits });
        left.push({ name: "Vannforsyning", value: bc.waterSupply });
        left.push({ name: "Oppvarming", value: bc.heating });
        right.push({ name: "Antall bad", value: bc.numBathrooms });
        right.push({ name: "Antall WC", value: bc.numWCs });

        right.push({ name: "Godkjent dato", value: formatDate(bc.applicationApprovedDate, 'dd.MM.yyyy', 'en') });
        right.push({ name: "Igangsatt dato", value: formatDate(bc.constructionStartDate, 'dd.MM.yyyy', 'en') });
        right.push({ name: "Bruksareal totalt", value: bc.usableArea });
        right.push({ name: "Primært bruksareal", value: bc.primaryUsableArea });
        right.push({ name: "Bruksareal bolig", value: bc.residentialUsableArea });
        right.push({ name: "Bruksareal annet", value: bc.otherUsableArea });

        return new Table(header, arealInfo, left, right);
    });

    onExpandClicked() {
        this.infoExpaned = !this.infoExpaned;
    }

    getDateByBuildingStatus(status: string): Date | null {
        const bc = this.buildingChange();
        if (!bc) return null;
        switch (status.toLowerCase()) {
            case "bygning er tatt i bruk":
                return bc.buildingAppliedDate;
            case "ferdigattest":
                return bc.completionCertificateDate;
            default:
                return null;
        }
    }
}
